module.exports = __webpack_public_path__ + "img/chat-right.f3a9f2b9.svg";